import { ToplineMetric } from 'app/model/metrics/topline-metric';
import { RestfulApiService } from 'app/services/restful-api.service';

class OverallMetricsService extends RestfulApiService<ToplineMetric> {
    protected getFormName(): string {
        return '';
    }

    protected getPath(): string {
        return 'metrics';
    }
}

export const overallMetricService = new OverallMetricsService();
